import cs from '../translations/cs.js'
import en from '../translations/en.js'

const languages = {
    cs,
    en,
}

// Získáme aktuální jazyk z data layer
const currentLanguage = typeof editorLang !== 'undefined' ? editorLang : getShoptetDataLayer('language')

// Funkce pro překlad klíčů
export function _t(key) {
    // Získáme překlad pro daný klíč a aktuální jazyk
    const translation = languages[currentLanguage][key]
    // Pokud překlad neexistuje, vypíšeme chybu do konzole a vrátíme původní klíč
    if (!translation) {
        console.error(`Překlad '${key}' nebyl nalezen pro jazyk '${currentLanguage}'`)
        return key
    }

    return translation
}

export function isMobile() {
    return $(window).width() <= 767
}

export function findParameter(labelText, hide = true) {
    const parameters = document.querySelectorAll('.p-param-block .detail-parameters tr')
    let dimValue = null

    parameters.forEach((parameter) => {
        const label = parameter.querySelector('th .row-header-label')?.textContent.trim()

        if (label === `${labelText}:`) {
            dimValue = parameter.querySelector('td').textContent
            if (hide) parameter.classList.add('hide')
        }
    })

    return dimValue?.trim()
}
